module.exports = __webpack_public_path__ + "static/media/warning.ed3e499f.svg";